import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "type" }
const _hoisted_2 = { class: "answer-options" }
const _hoisted_3 = {
  key: 0,
  class: "answer-options"
}

import {
  Co2QuizAnswer,
  Co2QuizQuestion,
  QuestionType,
} from '@/models/co2-quiz.model';
import { SimpleUserCo2QuizAnswer } from '@/models/user.model';
import { PropType, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2Question',
  props: {
  question: {
    type: Object as PropType<Co2QuizQuestion>,
    required: true,
  },
  selected: {
    type: Object as PropType<SimpleUserCo2QuizAnswer | null>,
    required: true,
  },
  followups: {
    type: Object as PropType<number[]>,
    required: true,
  },
},
  emits: ['update:answer'],
  setup(__props, { emit: __emit }) {

const props = __props;

const inputValue = ref<string>(
  props.selected?.inputValue ? `${props.selected?.inputValue}` : '',
);

const selectedAnswer = ref<Co2QuizAnswer | null>(null);

const emit = __emit;

function selectAnswer(answer: Co2QuizAnswer | null, inputValue?: string) {
  selectedAnswer.value = answer;
  emit('update:answer', { answer, inputValue });
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mb-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("h4", null, [
            _createTextVNode(_toDisplayString(__props.question.title) + " ", 1),
            _createElementVNode("span", _hoisted_1, _toDisplayString(__props.question.partQuestion
              ? 'Part'
              : __props.question.parentQuestion
              ? 'Sub'
              : __props.followups.includes(__props.question.id)
              ? 'Follow-up'
              : 'Main'), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...__props.question.answers].sort(
            (a, b) => a.index - b.index,
          ), (answer) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "answer-option",
                key: answer.id
              }, [
                _createVNode(_component_v_btn, {
                  color: __props.selected?.answer?.id === answer.id ? 'info' : '',
                  density: "compact",
                  block: "",
                  class: "mb-1",
                  onClick: ($event: any) => (selectAnswer(answer))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(answer.text.replace(/\s\(.+\)/g, '')), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "onClick"])
              ]))
            }), 128))
          ]),
          (
          __props.question.questionType === _unref(QuestionType).UserInput ||
          selectedAnswer.value?.isOther
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_text_field, {
                  modelValue: inputValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
                  label: "Input",
                  density: "compact",
                  "hide-details": "auto"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_btn, {
                  class: "ml-4",
                  color: "info",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (selectAnswer(selectedAnswer.value, inputValue.value)))
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Update")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})